import { render, staticRenderFns } from "./dynamicPage.vue?vue&type=template&id=e948a476&"
import script from "./dynamicPage.vue?vue&type=script&lang=js&"
export * from "./dynamicPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports